import "flickity/dist/flickity.min.css";
import Flickity from 'flickity-as-nav-for';


// Inspiration from here:
// https://codepen.io/devdojo/pen/OJNxawY

document.addEventListener("DOMContentLoaded", function(){
    setTimeout(function(){
        var replacers = document.querySelectorAll('[data-replace]');
        for(var i=0; i<replacers.length; i++){
            console.log('hit here2');
            let replaceClasses = JSON.parse(replacers[i].dataset.replace.replace(/'/g, '"'));
            Object.keys(replaceClasses).forEach(function(key) {
                replacers[i].classList.remove(key);
                replacers[i].classList.add(replaceClasses[key]);
            });
        }
    }, 1);
});


// import { jarallax, jarallaxVideo } from 'jarallax';

// jarallaxVideo();
// jarallax(document.querySelectorAll('.jarallax'), {
// 	speed: 0.2,
// 	videoSrc: 'https://www.youtube.com/watch?v=ab0TSkLe-E0'
//   });

var hasSlider = document.getElementsByClassName('slider');
if (hasSlider.length > 0) {

	var flkty = new Flickity('.slider', {
		// options...
	});

}

var hasHeaderSlider = document.getElementsByClassName('headerSlider');
if (hasHeaderSlider.length > 0) {

	const flickity = (() => {

		console.log('flickity for Header is here');

		// external js: flickity.pkgd.js
		var utils = window.fizzyUIUtils;

		var headerSlider = document.querySelector('.headerSlider');
		var flkty = new Flickity(headerSlider, {
			// sync: '.textBox',
			fade: false,
			pageDots: false,
			draggable: (document.querySelector('.neos-backend') ? false : true ),
			prevNextButtons: (document.querySelector('.neos-backend') ? true : false ),
			cellSelector: '.carousel-cell',
			autoPlay: 12000

		});

		// elements
		var cellsButtonGroup = document.querySelector('.button-group--cells');
		var cellsButtons = cellsButtonGroup.querySelectorAll('.cellButton');

		// update buttons on select
		flkty.on('select', function () {
			var previousSelectedButton = cellsButtonGroup.querySelector('.is-selected');
			var selectedButton = cellsButtonGroup.children[flkty.selectedIndex];
			previousSelectedButton.classList.remove('is-selected');
			selectedButton.classList.add('is-selected');
		});

		// cell select
		for (const [i, cellsButton] of cellsButtons.entries()) {
			cellsButton.addEventListener('click', function (event) {
				flkty.select(i);
			})
		}

		var carouselStatus = document.querySelector('.carousel-status');

		function updateStatus() {
			var slideNumber = flkty.selectedIndex + 1;
			carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
		}
		updateStatus();

		flkty.on('select', updateStatus);


	})();

}